import {
  Store,
  PricePrice,
  PriceStock,
  AlternativePrice,
  DeliveryOption,
  ShippingCollection,
  Price,
  Brand,
  OfferPrices,
} from 'src/types';
import { CurrentCampaign, ProductPriceType } from 'src/areas/product/types';
import { PriceDisplay } from 'src/components/price-list/types';
import { Rating } from 'components/rating/src/types';
import { ProductPriceClickStatus } from 'src/areas/product/actions/types';

export interface IPriceRowContext {
  offer: Offer;
  productId: number;
  productName?: string;
  productImage?: string | null;
  brand?: Brand | null;
  priceDisplay: PriceDisplay;
  campaign?: CurrentCampaign | null;
  showExpandButton: boolean;
}

export type Offer = {
  name?: string | null;
  price?: PricePrice | null;
  offerPrices?: OfferPrices | null;
  priceId?: string | null;
  priceType?: ProductPriceType | null;
  deliveryOptions?: DeliveryOption[] | null;
  store?: Store | null;
  featured: boolean;
  storeInfo?: (string | null)[] | null;
  rating?: Rating | undefined;
  stock?: PriceStock | null;
  externalUri?: string | null;
  alternativePrices?: (AlternativePrice | null)[] | null;
  authorizedDealer: boolean;
  isInternationalPrice: boolean;
  shipping?: ShippingCollection | null;
};

export interface IPriceRow {
  item: Price;
  index: number;
}

export const ProductPageProductClick = 'ProductPage';
type OnEvent = (
  e:
    | React.MouseEvent<HTMLAnchorElement, MouseEvent>
    | React.KeyboardEvent<HTMLAnchorElement>
    | React.TouchEvent<HTMLAnchorElement>
) => void;

export interface ITableLinkProps {
  rel: string;
  href: string | undefined;
  onClick: (e: React.MouseEvent) => void;
  onMouseDown?: OnEvent;
  onTouchStart?: OnEvent;
  onKeyDown?: OnEvent;
  target: string;
  disabled: boolean;
  featured?: boolean;
}

export interface IOfferContainerProps {
  rel: string;
  to: string | undefined;
  'aria-label': string;
  isExternal: boolean;
  onClick: (e: React.MouseEvent) => void;
  onMouseDown?: OnEvent;
  onTouchStart?: OnEvent;
  onKeyDown?: OnEvent;
  target: string;
  disabled: boolean;
  featured: boolean;
}

export enum ReportRowType {
  NONE = 'none',
  DEFAULT = 'default',
  ALTERNATIVE = 'alternative',
}

export type Align = 'left' | 'right';

export interface IRegularPriceRow {
  onClickOutBounce: (id: number, priceId?: string | null) => void;
  onPriceClick: (
    featured: boolean,
    status: ProductPriceClickStatus,
    isAlternative: boolean
  ) => void;
}

export interface IUnfeaturedColumns {
  tableLinkProps: ITableLinkProps;
  priceRowRef: React.RefObject<HTMLDivElement>;
  showDisabledInfo: boolean;
  setShowDisabledInfo: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface IFeaturedColumns {
  tableLinkProps: ITableLinkProps;
}
